import UIFlex from 'UIComponents/layout/UIFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import PrecedenceLevels from '../../constants/precedenceLevels';
import TwoFactorAuthMethod from '../../constants/twoFactorAuthMethod';
import { callForCode } from '../../data/authentication';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HelpMeSection = props => {
  const {
    currentAuthMethod,
    precedence,
    setCodeSentKey,
    setCurrentError,
    setCurrentAuthMethod,
    openTwoFactorRecovery,
    onChangePrecedence,
    setMobileAuthInterval,
    authMethod,
    hasSecondaryMethod
  } = props;
  function backupCodeSwitchLinkText() {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reAuth.helpMeSection.backupCodeSwitch.${currentAuthMethod === TwoFactorAuthMethod.BACKUP_CODE ? 'usePrimary' : 'useBackupCode'}`
    });
  }
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "column",
    className: "m-top-2",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "reAuth.helpMeSection.header"
    }), currentAuthMethod === 'SMS' && /*#__PURE__*/_jsx(UILink, {
      onClick: () => {
        callForCode(precedence === PrecedenceLevels.PRIMARY).then(res => {
          setCodeSentKey(res.key);
        }).catch(err => {
          setCurrentError(err.message);
        });
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.helpMeSection.callForCode"
      })
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: () => {
        setCurrentAuthMethod(currentAuthMethod === TwoFactorAuthMethod.BACKUP_CODE ? authMethod : TwoFactorAuthMethod.BACKUP_CODE);
        setMobileAuthInterval(undefined);
      },
      children: backupCodeSwitchLinkText()
    }), hasSecondaryMethod && /*#__PURE__*/_jsx(UILink, {
      onClick: onChangePrecedence,
      children: precedence === PrecedenceLevels.PRIMARY ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.helpMeSection.switchMethod.useSecondary"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.helpMeSection.switchMethod.usePrimary"
      })
    }), currentAuthMethod !== TwoFactorAuthMethod.HUBSPOT_AUTHENTICATOR && /*#__PURE__*/_jsx(UILink, {
      onClick: openTwoFactorRecovery,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.link"
      })
    })]
  });
};
export default HelpMeSection;